<template>
  <PageContent :top-sticked="hasConcept">
    <section class="section" v-if="hasConcept">
      <TopConcept :office="office" :business="business" />
    </section>

    <section class="section" v-if="notices.length">
      <Container>
        <Headline :level="2">お知らせ</Headline>
        <TopNotice :notices="notices" />
      </Container>
    </section>

    <section class="section bg-grey" v-if="events.length > 0">
      <Container :mobile-fluid="true">
        <Headline :level="2">次のご予定</Headline>
      </Container>
      <TopEvents :events="events" />
    </section>

    <section class="section bg-grey" v-if="step">
      <Container>
        <Headline :level="2">次のSTEP</Headline>
        <TopStep :step="step" />
      </Container>
    </section>

    <section class="section" v-if="categories.length > 0">
      <Container>
        <Headline :level="2">
          {{ $store.getters['app/getMenuName']('category') }}
        </Headline>
        <TopCategories :categories="categories" />
      </Container>
    </section>

    <section class="section">
      <Container>
        <Headline :level="2">コンテンツ一覧</Headline>
        <TopMenu :menus="menu" />
      </Container>
    </section>

    <section class="section" v-if="business">
      <Container>
        <Headline :level="2">挙式情報</Headline>
        <TopBusiness :business="business" :staff="$store.state.app.staff" />
      </Container>
    </section>

    <section class="section">
      <Container>
        <Headline :level="2">店舗情報</Headline>
        <TopOffice :office="office" />
      </Container>
    </section>
  </PageContent>
</template>

<script>
import TopConcept from '@/components/TopConcept.vue'
import TopNotice from '@/components/TopNotice.vue'
import TopCategories from '@/components/TopCategories.vue'
import TopMenu from '@/components/TopMenu.vue'
import TopOffice from '@/components/TopOffice.vue'
import TopBusiness from '@/components/TopBusiness.vue'
import TopStep from '@/components/TopStep.vue'
import TopEvents from '@/components/TopEvents.vue'
import businessApi from '@/api/business'
import topApi from '@/api/top'
import officeApi from '@/api/office'
import Menu from '@/utils/Menu'
import { renderError } from '@/utils/error'
import withEmpty from '@/filters/with-empty'

export default {
  components: {
    TopConcept,
    TopNotice,
    TopCategories,
    TopMenu,
    TopOffice,
    TopBusiness,
    TopStep,
    TopEvents,
  },
  metaInfo() {
    return {
      title: this.$store.state.app.pageName,
      bodyAttrs: { class: 'top' }
    }
  },
  data() {
    return {
      menu: [],
      categories: [],
      notices:[],
      step: null,
      events: [],
      business: null,
      office: {
        company_name: '',
        office_name: '',
        postcode1: '',
        postcode2: '',
        state: '',
        city: '',
        street: '',
        building_name: '',
        tel_area_no: '',
        tel_local_no: '',
        tel_no: '',
        official_site_url: '',
        access_url: '',
        office_information: '',
        portal_logo_image: ''
      }
    }
  },
  computed: {
    businessId() {
      return this.$store.getters['auth/businessId']
    },
    hasConcept() {
      return !!(this.business && this.business.concept_body)
    }
  },
  methods: {
    async fetchBusiness() {
      try {
        this.business = await businessApi.get(this.businessId)
      } catch(err) {
        renderError(err)
      }
    },
    async fetchMenu() {
      try {
        const result = await topApi.getMenu(this.businessId)
        this.menu = result.top_menu.map(m => new Menu(m))
        this.categories = result.top_category
      } catch (err) {
        renderError(err)
      }
    },
    async fetchTopNotice() {
      try {
        this.notices = await topApi.getNotices(this.businessId)
      } catch (err) {
        renderError(err)
      }
    },
    async fetchOffice() {
      try {
        this.office = await officeApi.get(this.businessId)
      } catch (err) {
        renderError(err)
      }
    },
    async fetchStepSchedules() {
      try {
        const response = await topApi.getStepSchedules(this.businessId)
        this.step = response.step
        this.events = response.meeting_list
      } catch (err) {
        renderError(err)
      }
    }
  },
  filters: {
    withEmpty
  },
  created() {
    this.$withLoading(() => Promise.all([
      this.fetchBusiness(),
      this.fetchMenu(),
      this.fetchOffice(),
      this.fetchTopNotice(),
      this.fetchStepSchedules(),
    ]))
  }
}
</script>
